import React from 'react';
import classNames from 'classnames';

function renderAmp() {
  const {
    context: {
      cssPrefix,
      facebookAppId,
    },
    extraClassNames,
    loadStyles,
    platforms,
    title,
    url,
  } = this.props; // eslint-disable-line

  return (
    <div
      className={classNames({
        [`${cssPrefix}__social`]: loadStyles,
        ...extraClassNames,
      })}
    >
      {platforms && platforms.map((singlePlatform, index) => (
        <amp-social-share
          aria-label={singlePlatform.label}
          data-param-app_id={singlePlatform.platform === 'facebook' ? facebookAppId : undefined}
          data-param-body={singlePlatform.platform === 'email' ? (url || singlePlatform.url) : undefined}
          data-param-href={singlePlatform.platform === 'facebook' ? url || singlePlatform.url : undefined}
          data-param-subject={singlePlatform.platform === 'email' ? title : undefined}
          data-param-text={title || singlePlatform.label}
          data-param-url={url || singlePlatform.url}
          data-target="_blank"
          key={`singlePlatform-${index}`}
          type={singlePlatform.platform}
        />
      ))}
    </div>
  );
}

export default renderAmp;
